/* unplugin-vue-components disabled */import script from "./Tab3.vue?vue&type=script&setup=true&lang=js"
export * from "./Tab3.vue?vue&type=script&setup=true&lang=js"

import "./Tab3.vue?vue&type=style&index=0&id=8e8eb9a6&lang=scss&rel=stylesheet%2Fscss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e8eb9a6"]])

export default __exports__